import { render } from "./SupportTable.vue?vue&type=template&id=0b935fde&scoped=true&ts=true"
import script from "./SupportTable.ts?vue&type=script&lang=ts"
export * from "./SupportTable.ts?vue&type=script&lang=ts"

import "./SupportTable.scss?vue&type=style&index=0&id=0b935fde&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b935fde"]])

export default __exports__